import React from "react";
import Logo from "../components/Logo";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <main className="privacy">
      <div className="privacy-header">
        <Link to={"/"} className="privacy-logo">
          <Logo />
        </Link>
        <h1>Privacy Policy</h1>
      </div>
      <div className="privacy-content">
        <p>
          SpendScope is committed to protecting your privacy. This Privacy
          Policy outlines how we collect, use, and safeguard your personal
          information when you use our services.
        </p>

        <p className="bold">
          Please note: We do not collect or store any personal or financial
          information from our users.
        </p>

        <h2>Information We Collect</h2>
        <p>
          We do not collect any personal, financial, or usage data. All
          information entered into SpendScope remains solely on your device and
          under your control.
        </p>

        <h2>How We Use Your Information</h2>
        <p>
          Since we do not collect user information, no data is used or processed
          by SpendScope beyond your personal device.
        </p>
        <h2>Data Sharing and Security</h2>
        <p>
          Third-Party Sharing: We do not share, sell, or transmit your data.
        </p>
        <p>
          Security Measures: Your data remains on your device, protected by your
          device's security settings.
        </p>
        <h2>Your Rights</h2>
        <p>
          You have complete control over any data you choose to input into
          SpendScope, as it is stored locally on your device.
        </p>

        <h2> Data Retention</h2>
        <p>
          We do not retain or access any user data, as all information is
          managed locally by you.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date.
        </p>
        <h2>Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at{" "}
          <a
            className="website-link"
            href="mailto:ignitedcodeart@gmail.com"
            rel="noreferrer"
            target="_blank"
          >
            ignitedcodeart@gmail.com
          </a>
          .
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
